<template>

    <div class="stepper text-center mb-5">

        <!-- Construit d'abord les lignes, afin de respecter les couches de z-index naturelles pour les steps soient "devant", et les lignes "en dessous" -->
        <div class="lines">
            <!-- Contruira 4 lignes -->
            <div v-for="i in (Object.keys($store.stepper).length - 1)" :key="i">

                <!-- Animation sur la ligne -->
                <div v-if="isFirstVisit && stepIndex == i">
                    <!-- Le appear est SUPER IMPORTANT, car il permet de déclencher l'animation au chargment initial du composant ! => 1 journée de perdue :'( -->
                    <transition name="line-anim" appear>
                        <div v-if="true" class="line"></div>
                    </transition>
                </div>

                <!-- Ligne sans animation -->
                <div v-else-if="$store.stepper[ Object.keys($store.stepper)[i] ].visited">
                    <div class="line"></div>
                </div>

            </div>
        </div>

        <div class="steps">
            <!-- Contruira 5 étapes -->
            <div v-for="(obj, key, i) in $store.stepper" :key="i">

                <!-- Actived -->
                <b-avatar v-if="obj.actived" size="3em" class="step-actived">{{ i + 1 }}</b-avatar>
                <div v-if="obj.actived" class="font-weight-bold">{{ obj.libelle }}</div>

                <!-- Visited -->
                <b-avatar v-if="obj.visited && !obj.actived" size="3em" class="step-visited">
                    <b-avatar class="number">{{ i + 1 }}</b-avatar>
                </b-avatar>
                <div v-if="obj.visited && !obj.actived">{{ obj.libelle }}</div>

                <!-- Innactif -->
                <b-avatar v-if="!obj.visited && !obj.actived" size="3em">{{ i + 1 }}</b-avatar>
                <div v-if="!obj.visited && !obj.actived">{{ obj.libelle }}</div>

            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: 'Stepper',
    props: {
        step: null,
        state: null,
        isFirstVisit: null
    },
    computed: {
        stepIndex() {
            return this.getStepIndex(this.step)
        }
    },
    methods: {
        getStepIndex(step) {
            var i = 0
            for(const key in this.$store.stepper) {
                if (step == key) {
                    return i
                }
                i++
            }
        }
    },
    watch: {
        // Ecriture "spéciale" afin de d'observer le changement de valeur de step, dès que le 1er chargement initial du composant a lieu
        step: {
            immediate: true,
            handler() {
                this.$actions.setStepper(this.step, this.state)
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.stepper {
    position: relative;
}

.steps, .lines {
    display: table;
    width: 100%;
}

.lines {
    position: absolute;
    top: 1.5em;
    padding-left: 10%;
    padding-right: 10%;
}

.steps > div, .lines > div {
    display: table-cell;
    width: 20%;
}

.step-actived, .step-visited {
    background-color: #e11a81;
}

.step-visited .number {
    color: #000000;
    background-color: #ffffff;
}

.line {
    height: 0.1em;
    width: 100%;
    background-color: #e11a81;
}

/** Animation de la ligne */
.line-anim-enter {
    width: 0;
}

.line-anim-enter-active {
    transition: width 1.5s;
}

.line-anim-enter-to {
    width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/Stepper.vue